import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import clsx from 'clsx';
import React from 'react';
import { useTranslation } from 'react-i18next';
import Icon from '../../components/Icon';
import { ISSUES_GROUP } from '../../constants/api';
export const TypeIcon = ({ defect, group, showIcon, onRuleClick }) => {
    const { t } = useTranslation();
    const isError = group === ISSUES_GROUP.ERRORS || defect.isError;
    const countOfDefects = new Intl.NumberFormat(t('numberFormatLocale')).format(defect.count);
    return _jsx("span", { className: clsx('most-common-issues__rules', onRuleClick && !defect.commitIssue && 'cursor--pointer'), "data-testid": 'defect-type', onClick: () => (onRuleClick ? onRuleClick(defect.tool, defect.name) : () => void 0), children: _jsxs("div", { className: clsx('most-common-issues__rules--row', isError ? 'text-danger' : 'text-warning'), children: [_jsx("span", { className: 'most-common-issues__rules--row-text', children: countOfDefects }), showIcon ? _jsx(Icon, { name: `exclamation-${isError ? 'circle' : 'triangle'}`, className: 'ml-2' }) : null] }) });
};
